import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MasterMenuSystemActions, AsyncActions } from './master-menu-system.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const masterMenuFeatureKey = 'masterMenu';

export interface MasterMenuState extends EntityState<any>, AsyncActionState {
  selectedTag: string | null;
  category: any;
  selectedCategory: any;
  locations: any;
  selectedLocation: any;
  searchFilter: SearchFilter;
  initSize: number;
  selectedRevote: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (revotes: any) => revotes.id,
  sortComparer: null,
});

export const initialState: MasterMenuState = adapter.getInitialState({
  selectedTag: null,
  category: [],
  selectedCategory: [],
  locations: [],
  selectedLocation: [],
  searchFilter: null,
  initSize: 20,
  selectedRevote: {},
  ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const masterMenuReducer = withLoadables<MasterMenuState>({
  loadActions,
  successActions,
  errorActions,
})(
  initialState,
  on(ManagementBaseActions.initMasterMenuSystem, (state: MasterMenuState, action) => ({
    ...initialState,
  })),
  on(MasterMenuSystemActions.loadAllSuccess, (state: MasterMenuState, { revotes }) => adapter.setAll(revotes, state)),
  on(MasterMenuSystemActions.loadAllCategoriesSuccess, (state: MasterMenuState, { categories }) => ({
    ...state,
    category: categories
  })),
  on(MasterMenuSystemActions.loadAllLocationsSuccess, (state: MasterMenuState, { locations }) => ({
    ...state,
    locations
  })),
  on(MasterMenuSystemActions.select, (state: MasterMenuState, action) => ({
    ...state,
    selectedRevote: { ...action.revote },
  })),
  on(MasterMenuSystemActions.searchRevote, (state: MasterMenuState, { filter }) => ({
    ...state,
    searchFilter: filter,
  })),
);
